export const FETCH_COST_OBJS_SUCCESS = 'FETCH_COST_OBJS_SUCCESS';
export const FETCHING_COST_OBJS = 'FETCHING_COST_OBJS';
export const CREATING_COST_OBJ = 'CREATING_COST_OBJ';
export const CREATE_COST_OBJ_SUCCESS = 'CREATE_COST_OBJ_SUCCESS';
export const FETCHING_LOCATION_TYPES = 'FETCHING_LOCATION_TYPES';
export const FETCH_LOCATION_TYPES_SUCCESS = 'FETCH_LOCATION_TYPES_SUCCESS';
export const FETCHING_COST_OBJ_BY_ALLOCATION_UNIT_ID = 'FETCHING_COST_OBJ_BY_ALLOCATION_UNIT_ID';
export const FETCH_COST_OBJ_BY_ALLOCATION_UNIT_ID_SUCCESS = 'FETCH_COST_OBJ_BY_ALLOCATION_UNIT_ID_SUCCESS';
export const FETCH_ALL_COST_OBJECTS = 'FETCH ALL COST OBJECTS';
export const FETCHING_ALL_COST_OBJECTS = 'FETCHING ALL COST OBJECTS';
export const SELECT_COST_OBJECT = 'SELECTED COST OBJECT';
export const CLEAR_COST_OBJECTS = 'CLEAR COST OBJECTS';
export const FETCHING_COST_OBJ = 'FETCHING_COST_OBJ';
export const FETCH_COST_OBJ_SUCCESS = 'FETCH_COST_OBJ_SUCCESS';
export const DELETE_COST_OBJ_FAILED = 'DELETE_COST_OBJ_FAILED';
export const RESET_DELETE_FAILED = 'RESET_DELETE_FAILED';




// WEBPACK FOOTER //
// ./src/redux/costObjs/CostObjsConstants.js